'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function UIButtonGroup(_ref) {
  var children = _ref.children,
      className = _ref.className,
      use = _ref.use,
      orientation = _ref.orientation,
      rest = _objectWithoutProperties(_ref, ['children', 'className', 'use', 'orientation']);

  var classes = (0, _reactUtils.classNames)('UIButtonGroup', 'private-button__group', className, {
    'private-floating-button-group__buttons private-floating-button-group__buttons--standalone': use === 'floating',
    'private-button__group--horizontal': orientation === 'horizontal',
    'private-button__group--vertical': orientation === 'vertical'
  });
  return _react2.default.createElement(
    'div',
    _extends({}, rest, { className: classes }),
    children
  );
}

UIButtonGroup.propTypes = {
  children: _react.PropTypes.node,
  className: _react.PropTypes.string,
  use: _react.PropTypes.oneOf(['default', 'floating']).isRequired,
  orientation: _react.PropTypes.oneOf(['horizontal', 'vertical'])
};

UIButtonGroup.defaultProps = {
  use: 'default',
  orientation: 'horizontal'
};

exports.default = UIButtonGroup;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1552/js/button/UIButtonGroup.js
// module id = 440
// module chunks = 0